import { TBMContactLayout } from '../../../components/Contact';
import { usePageTitle } from '../../../hooks';

export function TBMContacts() {
  usePageTitle('navigation:sections.contacts');
  return <TBMContactLayout />;
}
